export const Warning = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.6665 35L19.9998 3.33337L38.3332 35H1.6665ZM7.4165 31.6667H32.5832L19.9998 10L7.4165 31.6667ZM19.9998 30C20.4721 30 20.8682 29.84 21.1882 29.52C21.5071 29.2012 21.6665 28.8056 21.6665 28.3334C21.6665 27.8612 21.5071 27.4656 21.1882 27.1467C20.8682 26.8267 20.4721 26.6667 19.9998 26.6667C19.5276 26.6667 19.1321 26.8267 18.8132 27.1467C18.4932 27.4656 18.3332 27.8612 18.3332 28.3334C18.3332 28.8056 18.4932 29.2012 18.8132 29.52C19.1321 29.84 19.5276 30 19.9998 30ZM18.3332 25H21.6665V16.6667H18.3332V25Z"
      fill="#CC5E00"
    />
  </svg>
);
